import { useEffect, useRef, useState } from 'react'
import { registerSW } from 'virtual:pwa-register'
import { prepareForSafeUpgrade } from '../offline'

export function UpdatePrompt() {
  const [needsRefresh, setNeedsRefresh] = useState(false)
  const [offlineReady, setOfflineReady] = useState(false)
  const [preparing, setPreparing] = useState(false)
  const [updateError, setUpdateError] = useState<string>()
  const updateRef = useRef<((reloadPage?: boolean) => Promise<void>) | undefined>(undefined)

  useEffect(() => {
    updateRef.current = registerSW({
      immediate: false,
      onNeedRefresh: () => setNeedsRefresh(true),
      onOfflineReady: () => setOfflineReady(true),
    })
  }, [])

  if (!needsRefresh && !offlineReady && !updateError) return null

  const installUpdate = async () => {
    setPreparing(true)
    setUpdateError(undefined)
    try {
      await prepareForSafeUpgrade()
      await updateRef.current?.(true)
    } catch {
      setUpdateError('Update paused because queued work could not be checkpointed. Your current app remains open.')
      setPreparing(false)
    }
  }

  return (
    <div className="update-toast" role="status" aria-live="polite">
      <span>{updateError ?? (needsRefresh ? 'A safe update is ready. Queued work will be preserved.' : 'App shell is ready offline.')}</span>
      {needsRefresh && (
        <button type="button" className="button button-primary" disabled={preparing} onClick={() => void installUpdate()}>
          {preparing ? 'Preparing…' : 'Update'}
        </button>
      )}
      <button type="button" className="icon-button" aria-label="Dismiss update message" onClick={() => { setNeedsRefresh(false); setOfflineReady(false) }}>×</button>
    </div>
  )
}
